import styled from 'styled-components';

export const Wrapper = styled.section`
  height: 3.4em;
  background: #363636;
  color: #fff;
  display: flex;
  justify-content: flex-start;
  flex: 0 0 auto;
  margin-top: auto;
  align-items: center;
  font-size: 0.9rem;
  padding: 0 1em;
`;

export const Copyright = styled.div`
  display: inline-block;
  color: #fff;
  margin: 0 0.5em;
`;

export const LinkWrapper = styled.div`
  display: inline-block;
  margin: 0 0.5em;
  &:hover {
    text-decoration: underline;
  }
  & > a {
    color: #fff !important;
  }
`;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/Footer/styled-components.js